export default __webpack_public_path__ + "static/media/mockup.b2951bbf.png";